import dayjs, { Dayjs } from 'dayjs'

export class ArrayHelper {
  static getUniqueItems<T>(items: T[]): T[] {
    if (dayjs.isDayjs(items[0])) {
      return ArrayHelper.getUniqueDates(items as Dayjs[]) as T[]
    }
    if (items[0] instanceof Date) {
      return ArrayHelper.getUniqueDatesJS(items as Date[]) as T[]
    }
    const uniqueItems = Array.from(
      new Set(items.map((item) => JSON.stringify(item)))
    ).map((item) => JSON.parse(item))
    return uniqueItems
  }

  static getUniqueDatesJS(dates: Date[]): Date[] {
    const uniqueDates = Array.from(
      new Set(dates.map((date) => date.toISOString()))
    ).map((date) => new Date(date))
    return uniqueDates
  }

  static getUniqueDates(dates: Dayjs[]): Dayjs[] {
    const uniqueDates = Array.from(
      new Set(dates.map((date) => date.toISOString()))
    ).map((date) => dayjs(date))
    return uniqueDates
  }

  static getUniqueItemsFromVariousArrays(...arrays: any[][]) {
    const allItems = arrays.reduce((acc, array) => [...acc, ...array], [])
    return ArrayHelper.getUniqueItems(allItems)
  }

  static shortByProperty<T extends any[]>(
    items: T,
    property: keyof T[0],
    inverse = false
  ): T {
    return items.sort((a, b) => {
      if (a[property] < b[property]) {
        return inverse ? -1 : 1
      }
      if (a[property] > b[property]) {
        return inverse ? 1 : -1
      }
      return 0
    })
  }

  static toRecord<T extends Record<string | number, any>, K extends keyof T>(
    array: T[],
    selector: K
  ): Record<T[K], T> {
    return array.reduce(
      (acc, item) => ({ ...acc, [item[selector]]: item }),
      {} as Record<T[K], T>
    )
  }
}
